import React, { Component, Fragment } from "react";

//Components
import Popover from '@mui/material/Popover';
import { SketchPicker, TwitterPicker } from 'react-color';

//Style
import './style.scss'

const GroupColorContainer = (props) => {
    return (
        <div {...props} className={props.className}>
            {
                props.children
            }
        </div>
    )
}

const GroupColor = (props) => {
    return (
        <div  {...props} className={'groupColorClass'}>
            {
                props.children
            }
        </div>
    )
}

class ColorSelector extends Component {

    constructor(props) {
        super(props)

        this.state = {
            anchorEl: null,
            displayColorPicker: false,
            colorName: '#ffffff'
        }
    }

    componentDidMount() {
        const { color } = this.props
        if (color && this.state.colorName === '#ffffff') {
            this.setState({ colorName: color })
        }
    }

    componentDidUpdate(prevProps) {
        const { color: preColor } = prevProps
        const { color } = this.props
        if (preColor != color) {
            this.setState({ colorName: color })
        }
    }

    handleClick = (event) => {
        this.setState({ displayColorPicker: !this.state.displayColorPicker, anchorEl: event.currentTarget })
    };

    handleClose = () => {
        this.setState({ displayColorPicker: false, anchorEl: null })
    };

    handleChange = (color) => {
        this.setState({ colorName: color.hex })
        if (this.props.onHandeChange) {
            const { id } = this.props
            this.props.onHandeChange({ id: id, color: color.hex })
        }
    };

    renderPicker = (type) => {
        const {
            colors = [
                "#8677D9",
                "#5243AA",
                "#2584FF",
                "#0053CB",
                "#58D8A3",
                "#018759",
                "#08C6E6",
                "#06A2BF",
                "#FF7452",
                "#DE350D",
                "#FFC402",
                "#FF991F",
                "#6B778C",
                "#253858"
            ],
            triangle = "top-left",
            hideInput = false
        } = this.props;

        const { colorName } = this.state

        switch (type) {
            case 'twitter':
                return (
                    <TwitterPicker
                        colors={colors || []}
                        color={this.props.color}
                        triangle={triangle}
                        onChange={this.handleChange}
                        disableAlpha={true}
                        styles={hideInput ?
                            {
                                default: {
                                    input: {
                                        display: "none"
                                    },
                                    hash: {
                                        display: "none"
                                    }
                                }
                            } : {}
                        }
                    />
                );

            case 'sketch':
                return (
                    <SketchPicker
                        color={colorName}
                        onChange={this.handleChange}
                    />
                );

            default:
                return (
                    <SketchPicker
                        color={colorName}
                        onChange={this.handleChange}
                    />
                );
        }
    }

    render() {
        const { id, type = "sketch", className, popover = true } = this.props
        const { colorName } = this.state
        const open = Boolean(this.state.displayColorPicker);

        return (
            <Fragment key={id}>
                {
                    popover ?
                        <Fragment>
                            <GroupColorContainer className={className ? className : 'groupColorContainerClass'} aria-describedby={id} onClick={this.handleClick}>
                                <GroupColor style={{ backgroundColor: `${colorName}` }} />
                            </GroupColorContainer>
                            <Popover
                                id={id}
                                open={open}
                                anchorEl={this.state.anchorEl}
                                onClose={this.handleClose}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'center',
                                }}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'center',
                                }}
                            >
                                {this.renderPicker(type)}
                            </Popover>
                        </Fragment> :
                        <Fragment>
                            {this.renderPicker(type)}
                        </Fragment>
                }
            </Fragment>
        )
    }
}

export default ColorSelector